var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-inline-flex jds-items-center"},[_c('jds-icon',{staticClass:"jds-mr-1 jds-mb-1"},[_c('jds-glyph',{attrs:{"for":"location"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }